// import { navigate } from '@reach/router';
//
// export default (url) => navigate(url);

export default (url, data) => ({ pathname: url, ...data });
